import { render, staticRenderFns } from "./ColumnMenu.vue?vue&type=template&id=1ec0d166&"
import script from "./ColumnMenu.vue?vue&type=script&lang=js&"
export * from "./ColumnMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports